import React from 'react';
import { useSelector } from 'react-redux';

import {
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  coursePauseRescheduleModalStageSelector,
} from 'features/courseResume';
import CoursePauseRescheduleModalManageStage from '../CoursePauseRescheduleModalManageStage';
import CoursePauseRescheduleModalSuccessStage from '../CoursePauseRescheduleModalSuccessStage';
import CoursePauseRescheduleModalUnscheduleStage from '../CoursePauseRescheduleModalUnscheduleStage';

function CoursePauseRescheduleModalStageRenderer() {
  const modalStage = useSelector(coursePauseRescheduleModalStageSelector);

  switch (modalStage) {
    case COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.manage:
      return <CoursePauseRescheduleModalManageStage />;
    case COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.success:
      return <CoursePauseRescheduleModalSuccessStage />;
    case COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.unschedule:
      return <CoursePauseRescheduleModalUnscheduleStage />;
    default:
      return null;
  }
}

export default CoursePauseRescheduleModalStageRenderer;
